import { render, staticRenderFns } from "./new_02.vue?vue&type=template&id=df917b90&scoped=true"
import script from "./new_02.vue?vue&type=script&lang=js"
export * from "./new_02.vue?vue&type=script&lang=js"
import style0 from "./new_02.vue?vue&type=style&index=0&id=df917b90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df917b90",
  null
  
)

export default component.exports